'use client'

import { Blocks, Shield, Coins, FileCode } from 'lucide-react'
import ServicePageTemplate from '@/components/ServicePageTemplate'

export default function BlockchainDevelopmentPage() {
  return (
    <ServicePageTemplate
      slug="blockchain-development"
      title="Blockchain"
      titleHighlight="Development"
      description="Smart contracts, crypto wallets, NFT marketplaces, and decentralized applications built on cutting-edge blockchain technology."
      accentColor="from-orange-500 to-red-600"
      stats={[
        { value: '50+', label: 'DApps Built' },
        { value: '$100M+', label: 'TVL Managed' },
        { value: '100%', label: 'Audit Pass Rate' },
        { value: '5+', label: 'Chains Supported' }
      ]}
      services={[
        { icon: <FileCode className="w-6 h-6" />, title: 'Smart Contract Development', description: 'Secure, audited smart contracts for any use case.', features: ['Solidity & Rust', 'Security Auditing', 'Gas Optimization', 'Upgradeable Contracts'] },
        { icon: <Coins className="w-6 h-6" />, title: 'DeFi Solutions', description: 'Decentralized finance protocols and platforms.', features: ['DEX Development', 'Yield Farming', 'Lending Protocols', 'Token Economics'] },
        { icon: <Blocks className="w-6 h-6" />, title: 'NFT Marketplaces', description: 'Custom NFT platforms for digital assets.', features: ['ERC-721 & ERC-1155', 'Marketplace UI', 'Auction Systems', 'Royalty Management'] },
        { icon: <Shield className="w-6 h-6" />, title: 'Crypto Wallets', description: 'Secure multi-chain crypto wallet solutions.', features: ['Multi-Chain Support', 'Hardware Wallet Integration', 'Biometric Security', 'Transaction History'] },
      ]}
      technologies={[
        { name: 'Solidity', category: 'Smart Contracts' }, { name: 'Ethereum', category: 'Blockchain' },
        { name: 'Polygon', category: 'L2' }, { name: 'Web3.js', category: 'Library' },
        { name: 'Hardhat', category: 'Framework' }, { name: 'IPFS', category: 'Storage' },
        { name: 'The Graph', category: 'Indexing' }, { name: 'OpenZeppelin', category: 'Security' },
      ]}
      process={[
        { step: '01', title: 'Tokenomics Design', description: 'Define economics, governance, and utility models.' },
        { step: '02', title: 'Architecture', description: 'Design scalable on-chain and off-chain architecture.' },
        { step: '03', title: 'Smart Contracts', description: 'Develop and thoroughly test smart contracts.' },
        { step: '04', title: 'Frontend DApp', description: 'Build user-friendly decentralized interface.' },
        { step: '05', title: 'Security Audit', description: 'Third-party audit and vulnerability assessment.' },
        { step: '06', title: 'Mainnet Launch', description: 'Deploy to mainnet with monitoring and support.' },
      ]}
    />
  )
}
